export default __webpack_public_path__ + "6fa89fc965cf0f7be965e1d94636aab0.svg";